import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
var AuthGuard = /** @class */ (function () {
    function AuthGuard(router) {
        this.router = router;
    }
    AuthGuard.prototype.canActivate = function (route, state) {
        if (!localStorage.getItem('currentUser')) {
            var returnUrl = route.url.map(function (x) { return x.path; }).join('/');
            this.router.navigate(['/login', { returnUrl: returnUrl }], { queryParams: route.queryParams });
            return false;
        }
        return true;
    };
    AuthGuard.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AuthGuard.ctorParameters = function () { return [
        { type: Router }
    ]; };
    return AuthGuard;
}());
export { AuthGuard };
//# sourceMappingURL=auth.guard.js.map